import moment from 'moment'

const timeStamp = (value, format = 'DD/MM/YYYY HH:mm:ss') => {
  return value ? moment(value).format(format) : ''
}

export default timeStamp
